import React, { useCallback, useState } from "react";
import { Body2, ConfirmDialog } from "@activecollab/components";
import { t } from "i18next";
import PropTypes from "prop-types";
import { ProjectMembersAssigneePicker } from "~/components/ProjectMembersAssigneePicker";
import SubtaskRecurringTaskForm from "~/components/Subtasks/SubtaskRecurringTaskForm";
import RecurringSubtaskPanel from "~/components/tasks/CreateRecurringTaskModal/RecurringSubtaskPanel";

const RecurringSubtaskItem = ({
  name,
  assigneeId,
  projectId,
  isInEditMode,
  onDelete,
  onStartEdit,
  onCancelEdit,
  index,
  onChangeAssignee,
  onChange,
  hideFromClients,
  editable,
}) => {
  const onChangeAssigneeCallback = useCallback(
    (id) => {
      onChangeAssignee(id, index);
    },
    [index, onChangeAssignee]
  );

  const onUpdateSubtask = useCallback(
    (subtask) => {
      onChange(subtask, index);
    },
    [index, onChange]
  );

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const onHandleDelete = useCallback(() => {
    setOpenDeleteDialog(true);
  }, []);

  const onCancelDelete = useCallback(() => {
    setOpenDeleteDialog(false);
  }, []);

  const handleDelete = useCallback(() => {
    onDelete(index);
  }, [index, onDelete]);

  return (
    <div
      className="task subtask subtask_item tw-pl-0"
      data-testid="recurring-subtask-item"
    >
      {isInEditMode ? (
        <SubtaskRecurringTaskForm
          id={index}
          projectId={projectId}
          handleCancel={onCancelEdit}
          name={name}
          assigneeId={assigneeId}
          onSubmit={onUpdateSubtask}
          submitText={t("Update Subtask")}
          hideFromClients={hideFromClients}
        />
      ) : (
        <div className="tw-flex flex-row task_view_mode tw-justify-between tw-items-center">
          <Body2 className="task_name subtask_print_content tw-truncate tw-max-w-[500px]">{name}</Body2>
          <div
            className="tw-w-8 tw-h-8 subtask_assignee_wrapper tw-flex tw-items-center tw-justify-center tw-mr-2"
            style={{
              top: editable ? "0px" : "-4px",
            }}
          >
            <ProjectMembersAssigneePicker
              assigneeId={assigneeId}
              projectId={projectId}
              fakeAssigneeName=""
              onChange={onChangeAssigneeCallback}
              hiddenFromClient={hideFromClients}
            />
          </div>
          <RecurringSubtaskPanel
            onDelete={onHandleDelete}
            index={index}
            onEdit={onStartEdit}
          />
          <ConfirmDialog
            open={openDeleteDialog}
            dialogTitle={t("Delete Subtask?")}
            dialogContent={t("Subtask will be deleted permanently.")}
            confirmBtnText={t("Delete")}
            cancelBtnText={t("Cancel")}
            onConfirm={handleDelete}
            onCancel={onCancelDelete}
          />
        </div>
      )}
    </div>
  );
};

RecurringSubtaskItem.propTypes = {
  name: PropTypes.string,
  assigneeId: PropTypes.number,
  projectId: PropTypes.number,
  isInEditMode: PropTypes.bool,
  onDelete: PropTypes.func,
  onStartEdit: PropTypes.func,
  onCancelEdit: PropTypes.func,
  index: PropTypes.number,
  onChangeAssignee: PropTypes.func,
  onChange: PropTypes.func,
  hideFromClients: PropTypes.bool,
  editable: PropTypes.bool,
};

export default RecurringSubtaskItem;
